// Client layer (TS-2.5.03). The Team/Product swimlane-grouping toggle (decisions.md D-278; VISUAL
// restyle D-282 per owner feedback "it looks like the other filter options and it isn't a true
// filter"). Rendered as a SEGMENTED CONTROL - a connected two-segment pill (roadmap.css
// .eg-group-toggle__segments) visually distinct from the filter chips - while KEEPING the
// aria-pressed toggle-button markup D-227/D-278 established: aria-pressed toggle buttons are a
// correct ARIA idiom for a two-state mode switch, and every existing query (here, in
// GroupModeToggle.test.tsx and RoadmapPage.test.tsx) stays valid. D-282 records why radiogroup
// was considered and not chosen. Presentation only: RoadmapPage owns the mode state and its
// sessionStorage persistence (lib/groupModePreference.ts).
import type { RoadmapGroupMode } from "./lib/groupModePreference";
import { strings } from "../../strings";

export interface GroupModeToggleProps {
  readonly mode: RoadmapGroupMode;
  readonly onChange: (mode: RoadmapGroupMode) => void;
}

const S = strings.roadmap.groupToggle;

export function GroupModeToggle({ mode, onChange }: GroupModeToggleProps) {
  return (
    <div role="group" aria-label={S.aria} className="eg-group-toggle">
      <span className="eg-group-toggle__label">{S.label}</span>
      <div className="eg-group-toggle__segments">
        <button
          type="button"
          aria-pressed={mode === "team"}
          className="eg-group-toggle__segment"
          onClick={() => onChange("team")}
        >
          {S.team}
        </button>
        <button
          type="button"
          aria-pressed={mode === "product"}
          className="eg-group-toggle__segment"
          onClick={() => onChange("product")}
        >
          {S.product}
        </button>
      </div>
    </div>
  );
}
